
export const youtubeVideos = [
  {
    title: "No Time Ft 1K Phew",
    url: "https://www.youtube.com/embed/Pe6-Vx6jDMI?si=rY4NX7j379JuJQw-",
  },
  {
    title: "Ten Toes Down",
    url: "https://www.youtube.com/embed/CffEiS0LGJY?si=vTAWPPVAve3oPrFE",
  },
  {
    title: "Profit",
    url: "https://www.youtube.com/embed/BjbiCPs-K1Q?si=CVXkqhnFqNfCqBlx",
  },
  {
    title: "Atlas",
    url: "https://www.youtube.com/embed/vS99N9bsHV8?si=lNeNJqAIP6JrLyvg",
  },
  {
    title: "Higher",
    url: "https://www.youtube.com/embed/jAmItArZ-Nw?si=RVp3JCkHNB56vSy9",
  },
  {
    title: "Higher Cypher",
    url: "https://www.youtube.com/embed/YkWn2CaPas8?si=VWmz7Lj9WPJoVipO",
  },
  {
    title: "2Solid",
    url: "https://www.youtube.com/embed/E7VXUAkEobI?si=AXloqADY2D2yHrp9",
  },
  {
    title: "Get Right",
    url: "https://www.youtube.com/embed/XGcP6sRGE9I?si=rQYJhS1Ygog-DbCT",
  },
  {
    title: "Live JuneTeenth Atlanat 2023",
    url: "https://www.youtube.com/embed/PjOCoLaz2bQ?si=3T6FNihqhw6QKtJo",
  },
  {
    title: "Kingdom Building ATL",
    url: "https://www.youtube.com/embed/bluinPhlSxU?si=Q8SccmP8xUGgp8zq",
  },
  {
    title: "2Solid",
    url: "https://www.youtube.com/embed/E7VXUAkEobI?si=AXloqADY2D2yHrp9",
  },
];


export const commercialVideos = [
  {
    url: "https://www.youtube.com/embed/uZ6_3ZQO90M?si=H15GIpRydPBYTey9",
  },
  {
    url: "https://www.youtube.com/embed/wz8MofyvZ1U?si=kwyiPKin-UE2anRR",
  },
  {
    url: "https://www.youtube.com/embed/RQq4DuBBUXI?si=AdWNvSH-c2zyAS1t",
  },
];



